import { styled, Box } from '@mui/material';

const qlEditorBase = {
  padding: '4px !important',
  fontSize: '13px',
  maxHeight: '300px',
  overflowY: 'auto',
} as const;

export const HeliosRichTextCell = styled(Box)(({ theme }) => ({
  padding: '4px',
  overflow: 'hidden',
  maxWidth: '100%',
  [theme.breakpoints.up('md')]: {
    padding: '8px',
  },
  '& .ql-editor': {
    ...qlEditorBase,
    [theme.breakpoints.up('md')]: {
      fontSize: '14px',
    },
  },
}));

export const HeliosRichTextDetail = styled(Box)(({ theme }) => ({
  padding: '4px',
  height: '100%',
  width: '100%',
  overflow: 'hidden',
  [theme.breakpoints.up('md')]: {
    padding: '8px',
  },
  '& .ql-editor': {
    ...qlEditorBase,
    maxHeight: '400px',
    [theme.breakpoints.up('md')]: {
      fontSize: '14px',
    },
  },
}));

export const HeliosRichTextMobile = styled(Box)(() => ({
  '& .ql-editor': qlEditorBase,
}));

export const HeliosRichTextTableFunctions = styled(Box)(() => ({
  padding: '4px',
  overflow: 'hidden',
  '& .ql-editor': qlEditorBase,
}));
